import { Stack } from "@mui/material";
import { ShieldIcon } from "@src/appV2/redesign/EmergencyCredits/components/ShieldIcon";
import { ShieldWithSlashIcon } from "@src/appV2/redesign/EmergencyCredits/components/ShieldWithSlashIcon";
import { Text } from "@src/appV2/redesign/system/ui-components";

interface LatenessCreditStatusCardProps {
  hasCredit: boolean;
  shiftsUntilNextCredit: number;
}

export function LatenessCreditStatusCard(props: LatenessCreditStatusCardProps) {
  const { hasCredit, shiftsUntilNextCredit } = props;

  const title = hasCredit ? "Lateness Credit available" : "Lateness Credit already used";

  const shiftLabel = shiftsUntilNextCredit === 1 ? "shift" : "shifts";
  const description = hasCredit
    ? "You've earned yourself some flexibility! Your next late arrival will cost less."
    : `You've recently used this credit. Late arrivals cost more for the next ${shiftsUntilNextCredit} ${shiftLabel}.`;

  // eslint-disable-next-line no-restricted-syntax -- Green color from Figma design for lateness credit
  const colorWhenAvailable = "#619D50";

  return (
    <Stack sx={{ flexDirection: "column", gap: 3 }}>
      <Stack sx={{ alignItems: "center", flexDirection: "row", gap: 2 }}>
        {hasCredit ? (
          <ShieldIcon variant="outlined" sx={{ fontSize: "1.25rem", color: colorWhenAvailable }} />
        ) : (
          <ShieldWithSlashIcon sx={{ fontSize: "1.25rem" }} />
        )}
        <Text
          semibold
          variant="body1"
          sx={(theme) => ({
            color: hasCredit ? colorWhenAvailable : theme.palette.intent?.error.text,
          })}
        >
          {title}
        </Text>
      </Stack>

      <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
        {description}
      </Text>
    </Stack>
  );
}
